import { typedQueryClient, useTypedMutation } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeleteSnoozePayload } from "components";

export const useDeleteLeadsSnoozedSnoozeMutation = () =>
  useTypedMutation<DeleteSnoozePayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/snoozes/delete", payload);
    },
    onSuccess: ({ intervention_id, question_result_id }) => {
      const snoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listSnoozed);
      if (!snoozedLeads?.items?.length) return;

      const snoozeIdx = snoozedLeads.items.findIndex(i => (intervention_id ? i.intervention_id === intervention_id : i.question_result_id === question_result_id));
      if (snoozeIdx === -1) return;

      typedQueryClient.setQueryData(LeadsQueryKeys.listSnoozed, {
        ...snoozedLeads,
        items: snoozedLeads.items.toSpliced(snoozeIdx, 1),
        nb_items: snoozedLeads.nb_items - 1
      });
    }
  });
